var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSideIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0001 0.666687C6.65341 0.666687 0.666748 6.65335 0.666748 14C0.666748 21.3467 6.65341 27.3334 14.0001 27.3334C21.3467 27.3334 27.3334 21.3467 27.3334 14C27.3334 6.65335 21.3467 0.666687 14.0001 0.666687ZM16.3867 18C16.7734 18.3867 16.7734 19.0267 16.3867 19.4134C16.1867 19.6134 15.9334 19.7067 15.6801 19.7067C15.4267 19.7067 15.1734 19.6134 14.9734 19.4134L10.2667 14.7067C9.88008 14.32 9.88008 13.68 10.2667 13.2934L14.9734 8.58669C15.3601 8.20002 16.0001 8.20002 16.3867 8.58669C16.7734 8.97335 16.7734 9.61335 16.3867 10L12.3867 14L16.3867 18Z",
    fill: "#D5D5D5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideIcon);
export default __webpack_public_path__ + "static/media/side-icon.5b9dfd177175c43f42d805c9d00ba3cd.svg";
export { ForwardRef as ReactComponent };